"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecurringAvailability = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _ = require("./");
var _shared = require("../shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useRecurringAvailability = function useRecurringAvailability(_ref, cacheKey, options) {
  var clinician = _ref.clinician,
    intervalFrequency = _ref.intervalFrequency;
  var _useAuth = (0, _shared.useAuth)(),
    user = _useAuth.user;
  // moment.tz.guess() is needed for admin users
  var userTimeZone = user.profile.timeZone || _momentTimezone.default.tz.guess();
  (0, _lodash.defaults)(options, {
    ready: true
  });
  var availabilityReq = (0, _.useRequest)({
    url: (0, _.getRecurringAvailabilityUrl)(clinician.id, {
      timeZone: userTimeZone,
      intervalFrequency: intervalFrequency
    }),
    withErrorsHandler: false
  }, _objectSpread({
    refreshDeps: [cacheKey, intervalFrequency, clinician.id, userTimeZone],
    // Recurring availability slots are returned as day + HH:mm pairings along with
    // the time zone they were created in.
    formatResult: function formatResult(_ref2) {
      var recurringSlots = _ref2.recurringSlots;
      return {
        recurringSlots: recurringSlots.map(function (slot) {
          return (0, _.mapSlotToMoments)(slot, {
            isFromManagedAvailability: true
          });
        })
      };
    }
  }, options));
  return _objectSpread(_objectSpread({}, availabilityReq), {}, {
    data: availabilityReq.data || {
      recurringSlots: []
    }
  });
};
exports.useRecurringAvailability = useRecurringAvailability;